import * as Get from './get'
import * as Const from './const'

export default {
    ...Get,
    ...Const,
}